import { EntityService } from '../../../service/EntityService';

export class PaymentTypeService extends EntityService {

  static entity = 'api/app/payment';
  static getAll(): Promise<any> {
    return this.axios.get(`${this.entity}/all`).then(res => res.data);
  }

  static deleteMulti(ids: Array<string>): Promise<any> {
    return this.axios.post(`${this.entity}/multi-delete`, ids).then(res => res.data);
  }

}
